export default __webpack_public_path__ + "static/plugin-and-cli-5c1a584c82372f672ba8a7098e926938.png";